export const STAFF_TEST_FILTER_STORAGE_KEY = "launchpad-staff-hide-test-tenants";

export function readStoredStaffTestFilter(fallback = true): boolean {
  if (typeof window === "undefined") return fallback;
  try {
    const stored = window.localStorage.getItem(STAFF_TEST_FILTER_STORAGE_KEY);
    return stored === null ? fallback : stored !== "0";
  } catch {
    return fallback;
  }
}

/**
 * Test rows the reader can SEE right now.
 *
 * `TestFilterNote` answers the opposite question - what the filter took away.
 * With the filter OFF nothing answered THIS one: the queue header dropped from
 * "12 věcí k vyřízení · 16 testovacích skryto" to a bare "28 věcí k vyřízení",
 * the matrix title from "(4)" to "(21)", and not one row carried a mark. The
 * partner turns the filter off to look something up and from then on works in
 * a list where a dev seed is indistinguishable from a live client (audit P-12).
 *
 * Both row shapes are accepted on purpose: the queue carries `isTest`, the
 * matrix client `is_test`, and a second counting rule is how the two surfaces
 * would start disagreeing again.
 */
export function visibleTestCount(
  rows: ReadonlyArray<{ isTest?: boolean; is_test?: boolean }>
): number {
  return rows.filter((row) => row.isTest === true || row.is_test === true).length;
}

export function storeStaffTestFilter(value: boolean): void {
  try {
    window.localStorage.setItem(STAFF_TEST_FILTER_STORAGE_KEY, value ? "1" : "0");
  } catch {
    // The filter still works for the mounted surface when storage is denied.
  }
}
